export default __webpack_public_path__ + "static/Bildschirmfoto-2019-11-08-um-14.36.51-3e0d6a8562e382d69bf80b5414ad0d99.jpg";